/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { t, calc4Ext, calcCommon } from '../../utils/calculatorTranslations'
import { PageContext } from '../../context/PageContextProvider'
import { useParams, Link } from 'react-router-dom'
import { useState, useContext, useEffect } from 'react'
import { Attention, Info } from '../../icons'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import jsPDF from 'jspdf'
import { font } from '../../utils/font'
import { getWatermarkDataUrl } from '../../utils/watermark'
import { calculateFinalSettlement2026 } from '../Calculator4/terminationCalculator2026'

const formatCurrency = (val) => {
  const num = Number(val) || 0
  const [int, dec] = num.toFixed(2).split('.')
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + dec + ' ₼'
}

const Result4 = ({ className }) => {
  const params = useParams()
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [calcData, setCalcData] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        await PagesAPI.getMagazinePageInfo()
      } catch (e) {}

      // Try reading from sessionStorage
      let stored = null
      try {
        const raw = sessionStorage.getItem('termination_result_2026')
        if (raw) stored = JSON.parse(raw)
      } catch (e) {}

      if (stored && stored.simulations) {
        setCalcData(stored)
      } else {
        // Fallback: calculate default TC-65 benchmark or use URL params
        const salary = parseFloat(params.salary) || 2000
        const ground = params.ground || '70_b'
        const seniority = parseFloat(params.seniority) || 7

        const defaultResult = calculateFinalSettlement2026({
          monthlySalary: salary,
          normDaysInMonth: 21,
          actualDaysWorkedInMonth: 21,
          last12MonthsAverageSalary: 3400,
          vacationBreakdown: [
            { yearLabel: '2024/2025 iş ili', unusedDays: 8 },
            { yearLabel: '2025/2026 iş ili', unusedDays: 10 },
          ],
          terminationGround: ground,
          seniorityYears: seniority,
          hasEmployeeConsent: true,
          elapsedNoticeCalendarDays: 0,
          lastTwoMonthsTotalEarnings: 6800,
          lastTwoMonthsWorkDays: 41,
          nextMonthWorkDays: 21,
        })
        setCalcData(defaultResult)
      }
      setLoad(true)
    })()
  }, [params])

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  const generatePdf = async () => {
    if (!calcData) return

    const watermarkData = await getWatermarkDataUrl()
    const pdf = new jsPDF('p', 'mm', 'a4')
    pdf.addFileToVFS('WorkSans-normal.ttf', font)
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal')
    pdf.setFont('WorkSans')

    // Watermark Background
    if (watermarkData) {
      pdf.addImage(watermarkData, 'PNG', 30, 110, 150, 46)
    }

    // Header
    pdf.setFontSize(16)
    pdf.setTextColor(22, 111, 229)
    pdf.text('BPG CONSULTING CENTRE', 20, 22)

    pdf.setFontSize(11)
    pdf.setTextColor(15, 23, 42)
    pdf.text('ƏMƏK MÜQAVİLƏSİNƏ XİTAM VƏ SON HAQQ-HESAB PROTOKOLU (2026)', 20, 31)

    pdf.setFontSize(8.5)
    pdf.setTextColor(100, 116, 139)
    pdf.text(`Tarix: ${new Date().toLocaleDateString('az-AZ')}  |  Əsas: AR Əmək Məcəlləsi (m.70, 77, 140, 177) və KM Qərarı`, 20, 37)
    pdf.line(20, 40, 190, 40)

    // Summary Highlight Box
    pdf.setFillColor(239, 246, 255)
    pdf.rect(20, 44, 170, 28, 'F')
    pdf.setDrawColor(191, 219, 254)
    pdf.rect(20, 44, 170, 28, 'S')

    pdf.setFontSize(9)
    pdf.setTextColor(29, 78, 216)
    pdf.text('YANAŞMA A XALİS ÖDƏNİŞ (NK №58 üzrə MDSS=0):', 25, 52)
    pdf.setFontSize(15)
    pdf.setTextColor(22, 111, 229)
    pdf.text(formatCurrency(calcData.simulations.modelA.netApproachA), 25, 62)

    pdf.setFontSize(9)
    pdf.setTextColor(21, 128, 61)
    pdf.text('YANAŞMA B XALİS ÖDƏNİŞ (DVX 11.08.2026 izahı):', 110, 52)
    pdf.setFontSize(15)
    pdf.setTextColor(21, 128, 61)
    pdf.text(formatCurrency(calcData.simulations.modelA.netApproachB), 110, 62)

    // Key Parameters
    let y = 80
    pdf.setFontSize(10.5)
    pdf.setTextColor(15, 23, 42)
    pdf.text('1. Əsas Göstəricilər və Hesablama Əsasları', 20, y)
    y += 5

    const rows = [
      ['Xitam əsası:', calcData.inputs.terminationGround],
      ['Ümumi əmək stajı:', `${calcData.inputs.seniorityYears} il`],
      ['Bir günlük məzuniyyət haqqı (OGQ140, ƏM 140.3):', `${calcData.dailyRateOGQ140.toFixed(4)} AZN / gün`],
      ['Bir günlük orta əməkhaqqı (OGQ177, ƏM 177.2):', `${calcData.dailyRateOGQ177.toFixed(4)} AZN / gün`],
      ['Cari ayın əməkhaqqı (Brüt):', `${calcData.currentMonthSalary.gross.toFixed(2)} AZN`],
      ['Məzuniyyət kompensasiyası (Brüt):', `${calcData.vacation.totalGross.toFixed(2)} AZN`],
      ['Qanuni minimum müavinət (ƏM 77.3):', `${calcData.simulations.modelA.statutoryMinSeverance.toFixed(2)} AZN`],
      ['Xəbərdarlıq kompensasiyası (ƏM 77.4):', `${calcData.simulations.modelA.noticeCompensation.toFixed(2)} AZN`],
      ['CƏMİ BRÜT MƏBLƏĞ:', `${calcData.simulations.modelA.totalGross.toFixed(2)} AZN`],
    ]

    pdf.setFontSize(8.5)
    rows.forEach(([label, val]) => {
      pdf.setTextColor(100, 116, 139)
      pdf.text(label, 20, y)
      pdf.setTextColor(15, 23, 42)
      pdf.text(String(val), 120, y)
      y += 6
    })

    y += 6
    pdf.setFontSize(10.5)
    pdf.setTextColor(15, 23, 42)
    pdf.text('2. Audit Simulyasiyası A (241/12 Metodik Əmsalı)', 20, y)
    y += 5
    pdf.setFontSize(8)
    pdf.setTextColor(180, 83, 9)
    pdf.text('Qeyd: AR Əmək Məcəlləsində 241/12 adlanan formula yoxdur (İnzibati metodika simulyasiyasıdır).', 20, y)
    y += 6

    // Footer
    pdf.setFontSize(8)
    pdf.setTextColor(148, 163, 184)
    pdf.text('BPG Consulting - Azərbaycan Respublikasının Əmək və Vergi Qanunvericiliyi üzrə Rəsmi Hesablama Sistemi', 20, 285)

    pdf.save(`BPG_Son_Haqq_Hesab_${new Date().toISOString().slice(0, 10)}.pdf`)
  }

  if (!load || !calcData) return <Loading />

  const { currentMonthSalary, vacation, simulations, inputs } = calcData
  const modelA = simulations.modelA
  const modelB = simulations.modelB
  const modelC = simulations.modelC

  return (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={2} data={steps} />
      </div>

      <h1 className={styles.pageTitle}>Son Haqq-Hesab və Xitam Ödənişləri Nəticəsi</h1>

      {/* Condition 1 Warning if 74_1_d */}
      {inputs.terminationGround === '74_1_d' && (
        <div className={styles.alertWarning}>
          <Attention className={styles.alertIcon} />
          <div>
            <h4>Hüquqi Xəbərdarlıq: Məhkəmə Qərarı ilə Fəaliyyət Qabiliyyətsizliyi (ƏM 74.1.d)</h4>
            <p>
              Status: <strong>LEGAL_VERIFICATION_REQUIRED</strong>. ƏM 74 üzrə hüquqi status ayrıca təsdiq tələb
              edir. Avtomatik işdənçıxarma müavinəti hesablanmamışdır (0 AZN qəbul edilmişdir).
            </p>
          </div>
        </div>
      )}

      {/* Top Stat Cards */}
      <div className={styles.resultGrid}>
        <div className={`${styles.statCard} ${styles.heroCardA}`}>
          <div>
            <div className={styles.cardLabel}>Xalis Ödəniş (Yanaşma A — NK №58 Normativ Mətni)</div>
            <div className={`${styles.cardValue} ${styles.primary}`}>
              {formatCurrency(modelA.netApproachA)}
            </div>
          </div>
          <div className={styles.cardSub}>
            AR NK 09.06.1997-ci il №58 Qərarı (bənd 1): Məzuniyyət kompensasiyasına MDSS 0% tətbiq edilir.
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.heroCardB}`}>
          <div>
            <div className={styles.cardLabel}>Xalis Ödəniş (Yanaşma B — DVX 11.08.2026 İzahı)</div>
            <div className={`${styles.cardValue} ${styles.success}`}>
              {formatCurrency(modelA.netApproachB)}
            </div>
          </div>
          <div className={styles.cardSub}>
            DVX rəsmi inzibati izahı: Məzuniyyət kompensasiyasına hər iş ili üzrə ayrılıqda MDSS hesablanır.
          </div>
        </div>

        <div className={styles.statCard}>
          <div>
            <div className={styles.cardLabel}>Cəmi Brüt (Gross) Məbləğ</div>
            <div className={styles.cardValue}>{formatCurrency(modelA.totalGross)}</div>
          </div>
          <div className={styles.cardSub}>
            Cari maaş + Məzuniyyət + Qanuni müavinət + Xəbərdarlıq kompensasiyası
          </div>
        </div>

        <div className={styles.statCard}>
          <div>
            <div className={styles.cardLabel}>Qanuni Minimum Müavinət (ƏM 77.3)</div>
            <div className={styles.cardValue}>{formatCurrency(modelA.statutoryMinSeverance)}</div>
          </div>
          <div className={styles.cardSub}>
            Vergi və sosial sığortalardan tam azaddır (VM 102.1.4, SSQ 15)
          </div>
        </div>
      </div>

      {/* 4-Sütunlu Müqayisəli Rekonsilyasiya Cədvəli */}
      <div className={styles.auditSection}>
        <div className={styles.auditTitle}>
          <span>Müqayisəli 4-Sütunlu Hesablama və Rekonsilyasiya Cədvəli</span>
          <span className={styles.badge}>{t(calc4Ext.diffTitle, language)}</span>
        </div>

        {/* Legal Difference Warning Banner */}
        <div style={{ background: '#f8fafc', borderLeft: '4px solid #166fe5', padding: '12px 16px', borderRadius: '6px', marginBottom: '20px', fontSize: '13px', color: '#475569', lineHeight: '1.55' }}>
          <strong>⚠️ Hüquqi Fərq Qeydi:</strong> Bu iki yanaşma istifadəçiyə qanunvericiliklə verilmiş alternativ seçim hüququ deyildir. Burada qüvvədə olan normativ hüquqi aktın birbaşa mətni (AR NK 09.06.1997-ci il №58 Qərarı, bənd 1 üzrə MDSS hesablanmır) ilə vergi inzibatçılığının tətbiq izahı (DVX 11.08.2026 məktubu üzrə MDSS hesablanır) arasındakı fərq audit şəffaflığı üçün paralel nümayiş etdirilir.
        </div>

        <div className={styles.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th>{t(calc4Ext.paymentComponent, language)}</th>
                <th className="num">Brüt (Gross)</th>
                <th className="num">Yanaşma A: Normativ Aktın Mətni (NK №58)</th>
                <th className="num">Yanaşma B: DVX İnzibati İzahı (11.08.2026)</th>
              </tr>
            </thead>
            <tbody>
              {/* Blok 0: Cari Maaş */}
              <tr>
                <td className="bold">
                  Blok 0: Cari Ayın Faktiki Maaşı ({inputs.actualDaysWorkedInMonth}/{inputs.normDaysInMonth} iş günü — {formatCurrency(inputs.monthlySalary)} / {inputs.normDaysInMonth} gün × {inputs.actualDaysWorkedInMonth} gün)
                </td>
                <td className="num">{formatCurrency(currentMonthSalary.gross)}</td>
                <td className="num">
                  Tutulma: {formatCurrency(currentMonthSalary.totalDeductions)}
                  <br />
                  <small style={{ color: '#64748b' }}>
                    Net: {formatCurrency(currentMonthSalary.gross - currentMonthSalary.totalDeductions)}
                  </small>
                </td>
                <td className="num">
                  Tutulma: {formatCurrency(currentMonthSalary.totalDeductions)}
                  <br />
                  <small style={{ color: '#64748b' }}>
                    Net: {formatCurrency(currentMonthSalary.gross - currentMonthSalary.totalDeductions)}
                  </small>
                </td>
              </tr>

              {/* Blok 1 & 2: Məzuniyyət */}
              {vacation.breakdown.map((row, idx) => (
                <tr key={idx}>
                  <td>
                    İstifadə edilməmiş məzuniyyət: <strong>{row.yearLabel}</strong> ({row.unusedDays} gün @{' '}
                    {row.dailyRate} ₼/gün)
                  </td>
                  <td className="num">{formatCurrency(row.gross)}</td>
                  <td className="num">
                    Tutulma: {formatCurrency(row.totalDeductionsApproachA)} (MDSS: 0 ₼)
                    <br />
                    <small style={{ color: '#64748b' }}>
                      Net: {formatCurrency(row.gross - row.totalDeductionsApproachA)}
                    </small>
                  </td>
                  <td className="num">
                    Tutulma: {formatCurrency(row.totalDeductionsApproachB)} (MDSS: {formatCurrency(row.mdssApproachB)})
                    <br />
                    <small style={{ color: '#64748b' }}>
                      Net: {formatCurrency(row.gross - row.totalDeductionsApproachB)}
                    </small>
                  </td>
                </tr>
              ))}

              {/* Blok 3: Qanuni Minimum Müavinət */}
              <tr>
                <td className="bold">
                  Blok 3: Qanuni Minimum İşdənçıxarma Müavinəti (ƏM 77.3 / 77.7)
                </td>
                <td className="num">{formatCurrency(modelA.statutoryMinSeverance)}</td>
                <td className="num" style={{ color: '#059669' }}>
                  0.00 ₼ (Azadolma: VM 102.1.4)
                </td>
                <td className="num" style={{ color: '#059669' }}>
                  0.00 ₼ (Azadolma: VM 102.1.4)
                </td>
              </tr>

              {/* Blok 4: Xəbərdarlıq Kompensasiyası */}
              <tr>
                <td className="bold">
                  Blok 4: Xəbərdarlıq Müddətinin Əvəzinə Kompensasiya (ƏM 77.4)
                </td>
                <td className="num">{formatCurrency(modelA.noticeCompensation)}</td>
                <td className="num" style={{ color: '#059669' }}>
                  0.00 ₼ (Azadolma: VM 102.1.4)
                </td>
                <td className="num" style={{ color: '#059669' }}>
                  0.00 ₼ (Azadolma: VM 102.1.4)
                </td>
              </tr>

              {/* Total Row */}
              <tr className={styles.totalRow}>
                <td>CƏMİ YEKUN HESABLAŞMA (Gross / Tutulma / Net)</td>
                <td className="num bold">{formatCurrency(modelA.totalGross)}</td>
                <td className="num bold" style={{ color: '#166fe5' }}>
                  Tutulma: {formatCurrency(calcData.deductions.approachA.totalDeductions)}
                  <br />
                  Net: {formatCurrency(modelA.netApproachA)}
                </td>
                <td className="num bold" style={{ color: '#059669' }}>
                  Tutulma: {formatCurrency(calcData.deductions.approachB.totalDeductions)}
                  <br />
                  Net: {formatCurrency(modelA.netApproachB)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Audit Simulyasiya Modelləri (Condition 2 compliant) */}
      <div className={styles.auditSection}>
        <div className={styles.auditTitle}>
          <span>Orta Aylıq Əməkhaqqının (OMA) Müqayisəli Audit Simulyasiyaları</span>
          <span className={styles.badge}>ƏM 177.2 Tətbiq Modelləri</span>
        </div>

        <p style={{ fontSize: '13.5px', color: '#64748b', margin: '0 0 16px 0', lineHeight: 1.5 }}>
          <strong>Mühüm Hüquqi Qeyd:</strong> AR Əmək Məcəlləsinin 177.2-ci maddəsində <code>241/12 = 20.0833</code> adlı
          aylıq sabit multiplikator nəzərdə tutulmamışdır. Qanuna görə gündəlik orta əməkhaqqı əməkhaqqının saxlanıldığı
          iş günlərinə vurulur. Aşağıdakı modellər audit simulyasiyası məqsədilə təqdim edilir:
        </p>

        <div className={styles.simulationGrid}>
          {/* Model A */}
          <div className={styles.simCard}>
            <div className={styles.simHeader}>
              <h4>{modelA.title}</h4>
              <span className={`${styles.simBadge} ${styles.warning}`}>İnzibati Metodika</span>
            </div>
            <ul className={styles.simList}>
              <li>
                <span>Status:</span>
                <strong>{modelA.statusLabel}</strong>
              </li>
              <li>
                <span>Hesablanmış OMA:</span>
                <strong>{formatCurrency(modelA.oma)}</strong>
              </li>
              <li>
                <span>İşdənçıxarma müavinəti:</span>
                <strong>{formatCurrency(modelA.statutoryMinSeverance)}</strong>
              </li>
              <li>
                <span>Xəbərdarlıq kompensasiyası:</span>
                <strong>{formatCurrency(modelA.noticeCompensation)}</strong>
              </li>
              <li>
                <span>Cəmi Brüt:</span>
                <strong>{formatCurrency(modelA.totalGross)}</strong>
              </li>
              <li>
                <span>Xalis (Yanaşma A / B):</span>
                <strong>
                  {formatCurrency(modelA.netApproachA)} / {formatCurrency(modelA.netApproachB)}
                </strong>
              </li>
            </ul>
          </div>

          {/* Model B */}
          <div className={styles.simCard}>
            <div className={styles.simHeader}>
              <h4>{modelB.title}</h4>
              <span className={styles.simBadge}>Alternativ İnterpretasiya</span>
            </div>
            <ul className={styles.simList}>
              <li>
                <span>Status:</span>
                <strong>{modelB.statusLabel}</strong>
              </li>
              <li>
                <span>Hesablanmış OMA:</span>
                <strong>{formatCurrency(modelB.oma)}</strong>
              </li>
              <li>
                <span>İşdənçıxarma müavinəti:</span>
                <strong>{formatCurrency(modelB.statutoryMinSeverance)}</strong>
              </li>
              <li>
                <span>Xəbərdarlıq kompensasiyası:</span>
                <strong>{formatCurrency(modelB.noticeCompensation)}</strong>
              </li>
              <li>
                <span>Cəmi Brüt:</span>
                <strong>{formatCurrency(modelB.totalGross)}</strong>
              </li>
              <li>
                <span>Xalis (Yanaşma A / B):</span>
                <strong>
                  {formatCurrency(modelB.netApproachA)} / {formatCurrency(modelB.netApproachB)}
                </strong>
              </li>
            </ul>
          </div>

          {/* Model C */}
          <div className={styles.simCard}>
            <div className={styles.simHeader}>
              <h4>{modelC.title}</h4>
              <span className={styles.simBadge}>Nəzarət Hesabı</span>
            </div>
            <ul className={styles.simList}>
              <li>
                <span>Status:</span>
                <strong>{modelC.statusLabel}</strong>
              </li>
              <li>
                <span>Hesablanmış OMA:</span>
                <strong>{formatCurrency(modelC.oma)}</strong>
              </li>
              <li>
                <span>İşdənçıxarma müavinəti:</span>
                <strong>{formatCurrency(modelC.statutoryMinSeverance)}</strong>
              </li>
              <li>
                <span>Xəbərdarlıq kompensasiyası:</span>
                <strong>{formatCurrency(modelC.noticeCompensation)}</strong>
              </li>
              <li>
                <span>Cəmi Brüt:</span>
                <strong>{formatCurrency(modelC.totalGross)}</strong>
              </li>
              <li>
                <span>Xalis (Yanaşma A / B):</span>
                <strong>
                  {formatCurrency(modelC.netApproachA)} / {formatCurrency(modelC.netApproachB)}
                </strong>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Legal Disclaimer Box */}
      <div className={styles.disclaimerCard}>
        <h4>Normativ Hüquqi Mənbələr və Tətbiq Qeydləri</h4>
        <p>
          1. <strong>İşdənçıxarma Müavinəti və Xəbərdarlıq Təminatı:</strong> AR Əmək Məcəlləsinin 77.1 və 77.4-cü maddələri üzrə
          xəbərdarlıq müddətinin əvəzinə kompensasiya YALNIZ işçilərin sayının və ya ştatların ixtisarı (ƏM 70 "b") halında və
          işçinin yazılı razılığı ilə tətbiq olunur. Müəssisənin ləğvi (ƏM 70 "a") zamanı isə yalnız işdənçıxarma müavinəti (77.3)
          təmin edilir.
        </p>
        <p>
          2. <strong>Əlavə Məzuniyyətlər və Keçid Rejimi (KM 18.02.2026 Qərarı):</strong> AR Əmək Məcəlləsinin 144.3-cü maddəsinin hazırkı
          qanun mətnində əlavə məzuniyyətlərə kompensasiya verilməməsi müddəası görünsə də, AR Konstitusiya Məhkəməsinin 18.02.2026-cı il
          tarixli Qərarı ilə qanunverici orqan tərəfindən müvafiq dəyişiklik edilənədək ƏM 115, 116, 117 və 118-1 üzrə istifadə edilməmiş
          əlavə məzuniyyət günləri üçün də pul kompensasiyası ödənilməsi hüquqi qüvvəyə minmişdir. Bu hüquq hamıya avtomatik deyil,
          işçinin fərdi hüquqi statusu (zərərli şərait, staj, uşaq sayı, xüsusi ərazi) təsdiq edildikdə tətbiq olunur.
        </p>
        <p>
          3. <strong>Vergi və Sığorta Azadolmaları və Könüllü Ödənişlər:</strong> Əmək Məcəlləsinin 77-ci maddəsi üzrə qanuni minimum
          işdənçıxarma müavinətləri və xəbərdarlıq kompensasiyası Vergi Məcəlləsinin 102.1.4-cü maddəsinə və Sosial Sığorta haqqında
          Qanunun 15-ci maddəsinə əsasən gəlir vergisi, MDSS, İTS və İŞS-dən tam azaddır. Əgər işəgötürən kollektiv və ya əmək müqaviləsi ilə
          qanuni minimumdan artıq əlavə könüllü məbləğ təyin edərsə, həmin əlavə hissənin vergi rejimi ödənişin müqavilədəki hüquqi əsasından
          asılı olaraq müəyyən edilir.
        </p>
        <p>
          4. <strong>MDSS üzrə Tətbiq Fərqi (Yanaşma A və B):</strong> Qüvvədə olan normativ hüquqi aktın mətni (AR NK 09.06.1997-ci il №58
          Qərarı, bənd 1) üzrə məzuniyyət kompensasiyasına MDSS 0 ₼ tətbiq olunur; Dövlət Vergi Xidmətinin 11.08.2026 tarixli rəsmi izahı
          üzrə isə hər iş ili üzrə ayrılıqda MDSS hesablanır. Bu iki yanaşma paralel audit şəffaflığı məqsədilə təqdim edilmişdir.
        </p>
        <p style={{ marginTop: '12px', padding: '10px 14px', background: '#f1f5f9', borderRadius: '8px', borderLeft: '4px solid #64748b', fontSize: '12.5px', color: '#334155' }}>
          <strong>Yekun Hüquqi Qeyd:</strong> Bu kalkulyator hüquqi və maliyyə hesablamalarının ilkin/simulyativ qiymətləndirilməsi üçün nəzərdə tutulub. Xüsusi hallarda əmək müqaviləsinin şərtləri, kollektiv müqavilə, işçinin statusu və qüvvədə olan qanunvericilik nəzərə alınmaqla fərdi hüquqi/mühasibat yoxlaması tələb oluna bilər.
        </p>
      </div>

      {/* Buttons */}
      <div className={styles.buttons}>
        <Link to="/useful/calculator/4">Geri qayıt və dəyişdir</Link>
        <button type="button" onClick={generatePdf}>
          PDF Hesabatı Yüklə
        </button>
      </div>
    </section>
  )
}

export default Result4
